<template>
  <div v-loading="loading" element-loading-text="数据加载中..." style="height: 100%;width: 100%">
    <el-container style="height: 100%;width: 100%">
      <el-aside style="height: 100%;overflow-y: hidden;width: 220px">
        <div class="center">
          <el-row>
            <el-col :span="24">
              <el-select style="width: 100%;" @change="checkSaveStatus()" v-model="thing" filterable clearable
                         placeholder="物件名称">
                <el-option v-for="item in things" :key="item.id" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-button v-if="thing" class="button center" style="background-color: #0478e4;height: 50px">
                {{ thingName }}
              </el-button>
            </el-col>
          </el-row>
        </div>

        <div v-if="thing" style="height:44%;text-align: center;border: #d8dce6 2px solid;">
          <h2>前处理</h2>
          <div class="scrollbar" style="overflow-y: auto;height:90%;">
            <draggable
                :class="newPretreatmentFloorColorList.length > 0?'thingSelect pretreatment':'thingSelect initHeight pretreatment'"
                :list="newPretreatmentFloorColorList"
                ghost-class="ghost" chosen-class="chosenClass" :move="onMove" @add="onSort" animation="300"
                :sort="false" :group="group">
              <template #item="{ element }">
                <div class="item cursor" ref="item"
                     :style="element.newBatchNoList.length > 0?'height: auto;':'height: 70px'">
                  <div style="border-bottom: #0478e4 2px solid">
                    <span>{{ element.floor }}F&nbsp;-&nbsp;</span>
                    <span v-if="element.paint_type == 'ft'" style="color: #0478e4">粉</span>
                    <span v-if="element.paint_type == 'fs'" style="color: #67c23a">液</span>
                    <span v-if="element.paint_type == 'acl'" style="color: burlywood">共通</span>
                  </div>
                  <div :style="getStyle1(batchItem)" v-for="(batchItem,index) in element.newBatchNoList"
                       :key="batchItem.id"
                       :class="index>0?'item1':''">
                    <el-row>
                      <el-col :span="24">
                        <div>{{ batchItem.batch_no }}&nbsp;-&nbsp;{{ batchItem.color }}</div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </template>
            </draggable>
          </div>
        </div>


        <div v-if="thing" style="height:44%;text-align: center;border: #d8dce6 2px solid;margin-top: 5px">
          <h2>粉体&液体</h2>
          <div class="scrollbar" style="overflow-y: auto;height:90%;">
            <draggable
                :class="newFluorineFloorColorList.length > 0?'thingSelect powderAndLiquid':'thingSelect initHeight powderAndLiquid'"
                :list="newFluorineFloorColorList"
                ghost-class="ghost" chosen-class="chosenClass" @add="onSort" :move="onMove1" animation="300"
                :sort="false" :group="group1">
              <template #item="{ element }">
                <div class="item cursor" ref="item"
                     :style="element.newBatchNoList.length > 0?'height: auto;':'height: 70px'">
                  <div style="border-bottom: #0478e4 2px solid">
                    <span>{{ element.floor }}F&nbsp;-&nbsp;</span>
                    <span v-if="element.paint_type == 'ft'" style="color: #0478e4">粉</span>
                    <span v-if="element.paint_type == 'fs'" style="color: #67c23a">液</span>
                  </div>

                  <div :style="getStyle2(batchItem)" v-for="(batchItem,index) in element.newBatchNoList"
                       :key="batchItem.id"
                       :class="index>0?'item1':''">
                    <el-row>
                      <el-col :span="24">
                        <div>{{ batchItem.batch_no }}&nbsp;-&nbsp;{{ batchItem.color }}</div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </template>
            </draggable>
          </div>
        </div>
      </el-aside>
      <el-main style="padding: 0;width:90%;height: 100%;margin-left: 2px;overflow-x: hidden;overflow-y: hidden">
        <div class="border center" style="text-align: left;margin-left: 5px;">
          <el-input size="small" v-model="batchNo" style="width: 80px;margin-left: 5px" @keyup.enter="selectProductionAll" @change="selectProductionAll" placeholder="批号查询"></el-input>
          <el-button size="small" style="width: 60px;margin-left: 10px" type="primary" :loading="batchQueryLoading" @click="selectProductionAll">{{ $t('makeSchedule.paintingProductionScheduling.batchQuery') }}</el-button>
          <el-button size="small" class="week" style="margin-left: 20px" @click="clickThisWeek">{{ $t('makeSchedule.paintingProductionScheduling.thisWeek') }}</el-button>
          <el-button size="small" class="week" style="margin-left: 30px" @click="clickLastWeek">
            <el-icon>
              <ElIconArrowLeft/>
            </el-icon>
            {{ $t('makeSchedule.paintingProductionScheduling.lastWeek') }}
          </el-button>
          <el-date-picker size="small" v-model="week" format="M月-D日" value-format="MM-DD" type="daterange" disabled
                          range-separator="~" style="width: 180px;"/>
          <el-button size="small" class="week" @click="clickNextWeek">{{ $t('makeSchedule.paintingProductionScheduling.afterWeek') }}
            <el-icon>
              <ElIconArrowRight/>
            </el-icon>
          </el-button>
          <el-button size="small" style="width: 60px;margin-left: 10px" type="primary" :loading="saveAllDateLoading"
                     @click="saveAllDate">保存
          </el-button>
          <span style="margin-left: 20px">
            <span>{{ $t('makeSchedule.paintingProductionScheduling.colorTips') }}：</span>
            <span style="margin-left: 20px;background-color: #f56c6c">&nbsp;&nbsp;</span> <span>：{{ $t('makeSchedule.paintingProductionScheduling.processingNotCarriedOut') }}</span>
            <span style="margin-left: 10px;background-color: #e6a23c">&nbsp;&nbsp;</span> <span>：{{ $t('makeSchedule.paintingProductionScheduling.processingInProgress') }}</span>
            <span style="margin-left: 10px;background-color: #67c23a">&nbsp;&nbsp;</span> <span>：{{ $t('makeSchedule.paintingProductionScheduling.processingCompleted') }}</span>
          </span>
        </div>
        <div ref="total_height" style="display: flex;height: 96%;overflow: auto;">
          <div class="total_style" v-for="item in state.dataList" :key="item">
            <div class="border color time" :style="item.expireTimeClass">
              <div>{{ item.time }}</div>
              <div>{{ item.week }}</div>
            </div>
            <div v-if="!item.line_bool" :class="!item.line_bool?'prompt data_style1':''" :style="maxHeight">产线未开
            </div>
            <div v-if="item.line_bool" class="data_style">
              <div v-for="lineCnt in item.line_cnt" :key="lineCnt" class="data_style2" :style="item.expireTimeClass">
                <div class="data_style3">
                  <span v-if="lineCnt.dayShiftCnt == 'powder'" style="background-color: burlywood" class="data_style4">&nbsp;粉体&nbsp;</span>
                  <span v-if="lineCnt.dayShiftCnt == 'liquid'" style="background-color: #0486fe" class="data_style4">&nbsp;液体&nbsp;</span>
                  <span v-if="lineCnt.dayShiftCnt == 'pretreatment'" style="background-color: #2bd82f"
                        class="data_style4">&nbsp;前处理&nbsp;</span>
                  <span @click="editRemarks(lineCnt)" class="cursor"
                        style="font-size: 16px;color: #0478e4;float: right;"><el-icon><ElIconMoreFilled/></el-icon></span>
                  <!--                  <span v-if="lineCnt.nightShiftCnt == 'powder'" style="background-color: burlywood" class="data_style4_1">&nbsp;粉体&nbsp;</span>-->
                  <!--                  <span v-if="lineCnt.nightShiftCnt == 'liquid'" style="background-color: #0486fe" class="data_style4_1">&nbsp;液体&nbsp;</span>-->
                  <!--                  <span v-if="lineCnt.nightShiftCnt == 'pretreatment'" style="background-color: #2bd82f" class="data_style4_1">&nbsp;前处理&nbsp;</span>-->
                </div>
                <div style="height: 248px;overflow-y: auto">
                  <el-row v-if="lineCnt.remark != '' && lineCnt.remark != undefined" :style="border1[lineCnt.dayShiftCnt]!= undefined
                      && border1[lineCnt.dayShiftCnt]!= null?border1[lineCnt.dayShiftCnt]:border1[lineCnt.nightShiftCnt]"
                          style="text-align: center">
                    <el-col :span="24" style="background-color: whitesmoke">
                      <el-tooltip class="custom-tooltip" :content="lineCnt.remark" placement="top">
                        <div v-if="lineCnt.remark" class="overflow-text" style="height: 100%;color:black;">
                          {{ lineCnt.remark }}
                        </div>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                  <draggable :style="lineCnt.height" :class="lineCnt.class_line_name" :list="lineCnt.lineData"
                             ghost-class="ghost" filter=".forbid" chosen-class="chosenClass" animation="300"
                             @add="onSort" :sort="true" :move="onMove2" :group="item.expireTimeClass?item:'group'">
                    <template #item="{ element }">
                      <div>
                        <!--                      // 本物件显示信息-->
                        <div v-if="element.is_other_wujian == false" :style="border1[lineCnt.dayShiftCnt]!= undefined
                      && border1[lineCnt.dayShiftCnt]!= null?border1[lineCnt.dayShiftCnt]:border1[lineCnt.nightShiftCnt]"
                             class="item3"
                             :class="item.expireTimeClass?'forbid':''">
                          <el-row :style="border2[lineCnt.dayShiftCnt]!= undefined
                      && border2[lineCnt.dayShiftCnt]!= null?border2[lineCnt.dayShiftCnt]:border2[lineCnt.nightShiftCnt]">
                            <el-col :span="24">
                              <span>{{ element.wujian_short_name }}&nbsp;-&nbsp;</span>
                              <span>{{ element.floor }}F&nbsp;-&nbsp;</span>
                              <span>{{ paint_type_name[element.paint_type] }}</span>
                            </el-col>
                            <div style="margin-top: -22px;margin-left: 92%;">
                                <span @click="splitBatchItem(item.time,lineCnt,element)" class="cursor"
                                      style="font-size: 14px;"><el-icon><ElIconMoreFilled/></el-icon></span>
                            </div>
                          </el-row>

                          <el-row :style="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'?border2[lineCnt.dayShiftCnt]!= undefined
                                && border2[lineCnt.dayShiftCnt]!= null?border2[lineCnt.dayShiftCnt]:border2[lineCnt.nightShiftCnt]:''">
                            <el-col v-for="batchNo in element.batchData" :key="batchNo" :span="12">
                              <div>{{ batchNo }}</div>
                            </el-col>
                          </el-row>
                          <el-row
                              v-if="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'">
                            <el-col v-for="color in element.colorData" :key="color" :span="12">
                              <div>{{ color }}</div>
                            </el-col>
                          </el-row>
                        </div>
                        <!--                      // 非本物件显示信息-->
                        <div v-if="element.is_other_wujian == true" class="is_other_wujian_style"
                             :class="element.is_other_wujian == true?'forbid':''">

                          <el-row style="border-bottom: #8a9197 2px solid">
                            <el-col :span="24">
                              <span>{{ element.wujian_short_name }}&nbsp;-&nbsp;</span>
                              <span>{{ element.floor }}F&nbsp;-&nbsp;</span>
                              <span>{{ paint_type_name[element.paint_type] }}</span>
                            </el-col>
                          </el-row>
                          <el-row
                              :style="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'?'border-bottom: #8a9197 2px solid':''">
                            <el-col v-for="batchNo in element.batchData" :key="batchNo" :span="12">
                              <div>{{ batchNo }}</div>
                            </el-col>
                          </el-row>
                          <el-row
                              v-if="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'">
                            <el-col v-for="color in element.colorData" :key="color" :span="12">
                              <div>{{ color }}</div>
                            </el-col>
                          </el-row>
                        </div>
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
  <el-dialog title="编辑" v-model="splitBatchItemBool" width="60%">
    <el-form :model="formWujianData" label-width="100px">
      <el-row>
        <el-col :span="24">
          <div style="text-align: center;font-size: 30px;height: 50px">{{ formWujianData.wujian_short_name }}</div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="楼层信息：">
            <el-input v-model="formWujianData.floor" disabled placeholder="楼层信息" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="排产日期：">
            <el-date-picker v-model="formWujianData.production_scheduling_date" disabled type="date"
                            placeholder="排产日期" style="width: 90%"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排产产线：">
            <div v-if="!lineBool && formWujianData.lineCnt == 'powder'" class="border"
                 style="height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">粉体
            </div> <!--  白班-->
            <div v-if="!lineBool && formWujianData.lineCnt == 'liquid'" class="border"
                 style="height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">液体
            </div> <!--  白班-->
            <div v-if="!lineBool && formWujianData.lineCnt == 'pretreatment'" class="border"
                 style="height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">前处理
            </div> <!--  白班-->
            <!--            <div v-if="lineBool && formWujianData.lineCnt == 'powder'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">粉体夜班</div> &lt;!&ndash;  夜班&ndash;&gt;-->
            <!--            <div v-if="lineBool && formWujianData.lineCnt == 'liquid'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">液体夜班</div> &lt;!&ndash;  夜班&ndash;&gt;-->
            <!--            <div v-if="lineBool && formWujianData.lineCnt == 'pretreatment'" class="border" style="height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">前处理夜班</div> &lt;!&ndash;  夜班&ndash;&gt;-->
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="排产批号：">
            <el-select style="width: 95%;" v-model="formWujianData.newBatchNoList" multiple filterable clearable
                       placeholder="物件名称">
              <el-option v-for="item in this.batchNoList" :key="item.id" :label="item.batch_no + ' - ' + item.color"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="width: 90%;display: flex;flex-direction: column;align-items: center">
        <el-button type="primary" style="width: 100px;" @click="saveWujianOneBatchData()">提交</el-button>
      </div>
    </el-form>
  </el-dialog>
  <el-dialog width="30%" title="提示" :show-close="false" :close-on-click-modal=false v-model="confirmBool" draggable>
    <span style="font-size: 20px">【{{ wujianId ? wujianId : thing }}物件】进行了排产，您是否保存？</span>
    <div
        style="width: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 40px;">
      <el-button type="primary" style="width: 100px;" @click="cancelEvent()">取消</el-button>
      <el-button type="primary" style="width: 100px;" @click="confirmEvent()">保存</el-button>
    </div>
  </el-dialog>

  <el-dialog width="40%" title="编辑产线备注" :show-close="false" :close-on-click-modal=false v-model="remarkBool"
             draggable>
    <el-row>
      <el-col :span="24">
        <el-form-item label="备注：">
          <el-input style="width: 95%;" v-model="remark" clearable placeholder="备注">
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div
        style="width: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 10px;">
      <el-button type="primary" style="width: 100px;" @click="cancelEvent1()">取消</el-button>
      <el-button type="primary" style="width: 100px;" @click="confirmEvent2()">提交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import draggable from "vuedraggable";
import moment from "moment";

export default {
  name: "PaintingProductionScheduling",
  components: {draggable},
  data() {
    return {
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      assemblyEndTime: '',
      group: {
        name: 'group',
        pull: true,
        put: true,  //允许拖入
        disabledPark: true
      },
      group1: {
        name: 'group',
        pull: true,
        put: true,  //允许拖入
      },
      things: [],
      thing: '',
      wujianId: '',
      thingName: '',
      newPretreatmentFloorColorList: [], //总批号数据（包括楼层和色）前处理
      newFluorineFloorColorList: [], //总批号数据（包括楼层和色）弗素
      batchNoList: [],//修改前的批号数据
      state: {
        dataList: [],
      },
      week: [], //时间组件数据
      weekList: [], //一个星期的时间
      params: {
        startTime: '',  //开始时间
        endTime: '',    //结束时间
        from_className: '',//拖拽结束前的div class名称
        to_className: '', //拖拽结束后的div class名称
        to_lineData: {},
        from_lineData: {},
        currentLineData: {}
      },
      splitBatchItemBool: false, //控制物料详情页面
      formWujianData: {},
      plan_production_quantity: '',
      saveAllDateLoading: false,
      batchQueryLoading: false,
      oneProductionSchedulingLoading: false,//一键排产
      oneCleanLoading: false,//一键清除
      oneMoveBackLoading: false,//一键平移
      lineBool: false,//false表示白班 true表示夜班
      loading: false,
      maxHeight: "",//获取页面的最大高度
      confirmBool: false,
      remark: '',
      remarkBool: false,
      remarkParams: {},
      paint_type_name: {
        'ft': '粉体',
        'fs': '液体',
        'acl': '共通'
      },

      border1: {
        'pretreatment': 'border: #2bd82f 2px solid',
        'powder': 'border: burlywood 2px solid;',
        'liquid': 'border: #0486fe 2px solid'
      },

      border2: {
        'pretreatment': 'border-bottom: #2bd82f 2px solid',
        'powder': 'border-bottom: burlywood 2px solid;',
        'liquid': 'border-bottom: #0486fe 2px solid'
      },
      batchNo:''
    }
  }, methods: {
    onMove(e) {
      //console.log("powderAndLiquid=", e.draggedContext.element)
      //允许停靠
      if (e.to.className.includes('pretreatment')) {
        return true;
      }

      return false;
    },
    onMove1(e) {
      //允许停靠
      if (e.to.className.includes('powder') && e.draggedContext.element.paint_type == 'ft'
          || e.to.className.includes('liquid') && e.draggedContext.element.paint_type == 'fs') {
        return true;
      }

      return false;
    },
    onMove2(e) {
      //console.log("powderAndLiquid=", e.to.className)
      //console.log("powderAndLiquid1111111111=", e.from.className)
      //允许停靠
      if (e.to.className.includes('powder') && e.from.className.includes('powder')
          || e.to.className.includes('liquid') && e.from.className.includes('liquid')
          || e.from.className.includes('powderAndLiquid') && e.to.className.includes('powder')
          || e.to.className.includes('powderAndLiquid') && e.from.className.includes('liquid')) {
        return true;
      }

      if (e.to.className.includes('pretreatment') && e.from.className.includes('pretreatment')
          || e.from.className.includes('pretreatment') && e.to.className.includes('pretreatment')) {
        return true;
      }

      return false;
    },
    confirmEvent() {
      this.confirmBool = false;
      this.saveAllDate1();
    },
    cancelEvent() {
      this.confirmBool = false;
      this.deletePaintingSaveStatus();
    },
    async deletePaintingSaveStatus() {
      this.loading = true;
      let params = {thing: this.thing, wujianId: this.wujianId, startTime: this.startTime, endTime: this.endTime}
      this.$axios.post('mfg/paintingProduction/deletePaintingSaveStatus', params).then(async response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.newPretreatmentFloorColorList = res.data.newPretreatmentFloorColorList;
        this.newFluorineFloorColorList = res.data.newFluorineFloorColorList;
        await this.getBatchNoBoolAndThingName();
        await this.getCalendarLineData(this.thing, this.startTime, this.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    async checkSaveStatus() {
      let params = {thing: this.thing, startTime: this.startTime, endTime: this.endTime}
      if(localStorage.getItem("paintingWujianId") != null && localStorage.getItem("paintingWujianId") != 'undefined') {
        this.wujianId = JSON.parse(localStorage.getItem("paintingWujianId"))
      }
      if (this.wujianId) {
        params.thing = this.wujianId;
      }
      //console.log("wujianId2=", params.thing)
      this.$axios.post('mfg/paintingProduction/checkSaveStatus', params).then(async response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        //console.log("checkSaveStatus==", res.data)
        if (res.data) {
          this.confirmBool = true;
        } else {
          localStorage.setItem("paintingWujianId", JSON.stringify(this.thing))
          await this.getBatchNos();
        }
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    async getBatchNos() {
      if (!this.thing) {
        return this.$message.error("物件不能为空");
      }
      this.loading = true;
      this.$axios.post('mfg/paintingProduction/getBatchNos', this.thing).then(async response => {
        let res = response.data
        if (res.code !== 0) {
          this.loading = false;
          return this.$message.error(res.message);
        }

        this.newPretreatmentFloorColorList = res.data.newPretreatmentFloorColorList;
        this.newFluorineFloorColorList = res.data.newFluorineFloorColorList;
        await this.getBatchNoBoolAndThingName();
        //console.log("floorColorList=", this.newPretreatmentFloorColorList)
        //console.log("newFluorineFloorColorList=", this.newFluorineFloorColorList)
        await this.getCalendarLineData(this.thing, this.startTime, this.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    getBatchNoBoolAndThingName() {
      //显示物件名称
      for (let item of this.things) {
        if (item.value == this.thing) {
          this.thingName = item.label;
        }
      }
    },
    getWuJianInFo() {
      this.$axios.post('mfg/wujianPlan/getWujianName').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("获取数据失败");
        }

        this.things = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    onSort(e) {
      this.loading = true;
      //当插入、移除、改变位置时会触发该事件
      this.params.from_className = e.from.className;
      this.params.to_className = e.to.className;
      this.params.currentLineData = e.item._underlying_vm_;
      //console.log("currentLineData===", e)
      for (let obj1 of this.state.dataList) {
        for (let obj2 of obj1.line_cnt) {
          if (this.params.to_className == obj2.class_line_name) {
            this.params.to_lineData = obj2.lineData;
          }

          if (this.params.from_className == obj2.class_line_name) {
            this.params.from_lineData = obj2.lineData;
          }
        }
      }
      this.params.startTime = this.startTime;
      this.params.endTime = this.endTime;
      //console.log("params===", this.params)
      //拖回该物件批号数据源
      if (this.params.to_className.toString().includes('thingSelect')) {
        //添加取消排产成功提示
        this.params.prompt = true;
        this.updateCalendarLineData();
        return;
      }

      //各个产线上线批号的数据相互拖拽
      if (this.params.to_className.toString().includes("shift_line") && this.params.from_className.toString().includes("shift_line")) {
        this.updateCalendarLineData();
        return;
      }

      //处理批号池数据拖到各个产线上线批号的数据
      this.updateCalendarLineData();
    },
    async updateCalendarLineData() {
      this.$axios.post('mfg/paintingProduction/updateCalendarLineData', this.params).then(async response => {
        let res = response.data
        if (res.code !== 0) {
          this.loading = false;
          await this.getBatchNos();
          return this.$message.error(res.message);
        }

        if (this.params.prompt) {
          this.$message.success("取消排产成功");
        } else {
          this.$message.success("排产成功");
        }

        this.params.prompt = false;
        await this.getBatchNos();
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    async getCalendarLineData(thing, startTime, endTime) {
      let params = {thing: thing, startTime: startTime, endTime: endTime, weekList: this.weekList}
      this.$axios.post('mfg/paintingProduction/getCalendarLineData', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.loading = false;
          return this.$message.error(res.message);
        }
        this.state.dataList = res.data;
        this.maxHeight = '';
        //console.log("dataList=", res.data)
        setTimeout(() => {
          this.getMaxHeight();
        }, 200);
        this.loading = false;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    //物件计划详情
    splitBatchItem(time, lineCnt, element) {
      this.batchNoList = element.newBatchNoList;
      this.formWujianData = {};
      this.splitBatchItemBool = true;
      let cnt;
      if (lineCnt.dayShiftCnt) {
        cnt = lineCnt.dayShiftCnt;
        this.lineBool = false;
      } else {
        cnt = lineCnt.nightShiftCnt;
        this.lineBool = true;
      }

      //console.log("element===", element)
      this.formWujianData.paint_type = element.paint_type
      this.formWujianData.wujian_short_name = element.wujian_short_name;
      this.formWujianData.floor = element.floor;
      this.formWujianData.newBatchNoList = [];
      for (let batchNo of element.newBatchNoList) {
        this.formWujianData.newBatchNoList.push(batchNo.id)
      }
      this.formWujianData.form_className = lineCnt.class_line_name;
      this.formWujianData.wujian_id = element.wujian_id;
      this.formWujianData.lineCnt = cnt;
      let timeString = time.toString().substring(0, time.toString().length - 1);
      let timeList = timeString.toString().split("月");
      let month = timeList[0];
      let day = timeList[1];
      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }

      let date;
      //特殊处理跨年的
      if (this.startTime.substring(0,4) !== this.endTime.substring(0,4)) {
        if (parseInt(month) < 12) { //这是下一年
          date = this.endTime.substring(0,4) + '-' + month + '-' + day;
        } else {
          date = this.startTime.substring(0,4) + '-' + month + '-' + day;
        }
      } else {
        date = this.startTime.substring(0,4) + '-' + month + '-' + day;
      }

      this.formWujianData.production_scheduling_date = date;
      //console.log("formWujianData=", this.formWujianData)
    },
    async saveAllDate1() {
      this.saveAllDateLoading = true;
      let params = {startTime: this.startTime, endTime: this.endTime, wujian_id: this.wujianId}
      if (!this.wujianId) {
        params.wujian_id = this.thing;
      }
      this.$axios.post('mfg/paintingProduction/saveAllDate', params).then(async response => {
        this.saveAllDateLoading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        await this.getBatchNos();
        return this.$message.success("保存成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    saveAllDate() {
      this.saveAllDateLoading = true;
      let params = {startTime: this.startTime, endTime: this.endTime, wujian_id: this.thing}
      this.$axios.post('mfg/paintingProduction/saveAllDate', params).then(response => {
        this.saveAllDateLoading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        return this.$message.success("保存成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    // oneClickProductionScheduling() {
    //   this.oneProductionSchedulingLoading = true;
    //   this.loading = true;
    //   let params = {wujian_id: this.thing, floorColorList:this.newPretreatmentFloorColorList, dataList: this.state.dataList}
    //   this.$axios.post('mfg/paintingProduction/oneClickProductionScheduling', params).then(response => {
    //     this.oneProductionSchedulingLoading = false;
    //     let res = response.data
    //     if (res.code !== 0){
    //       this.loading = false;
    //       return this.$message.error(res.message);
    //     }
    //
    //     this.getBatchNos();
    //     return this.$message.success("排产成功");
    //   }, error => {
    //     this.$message.error(`页面数据加载失败` + error.message);
    //     this.loading = false;
    //   })
    // },
    // oneClickClean() {
    //   ElMessageBox.confirm(
    //       '清除未过期的排产数据，清除后，需要重新排产，您确定要清除吗?',
    //       '警告',
    //       {
    //         confirmButtonText: '确定清除',
    //         cancelButtonText: '取消清除',
    //         type: 'warning',
    //       }
    //   ).then(() => {
    //     this.oneCleanLoading = true;
    //     this.loading = true;
    //     let params = {wujian_id: this.thing, endTime: this.endTime}
    //     this.$axios.post('mfg/paintingProduction/oneClickClean', params).then(response => {
    //       this.oneCleanLoading = false;
    //       let res = response.data
    //       if (res.code !== 0) {
    //         this.loading = false;
    //         return this.$message.error(res.message);
    //       }
    //
    //       this.getBatchNos();
    //       return this.$message.success("清除成功");
    //     }, error => {
    //       this.$message.error(`页面数据加载失败` + error.message);
    //       this.loading = false;
    //     })
    //   }).catch(() => {
    //     ElMessage({
    //       type: 'info',
    //       message: '取消成功',
    //     })
    //   })
    // },
    // oneClickMoveBack() {
    //   ElMessageBox.confirm(
    //       '未过期的排产数据往后移动一天，您确定移动吗?',
    //       '警告',
    //       {
    //         confirmButtonText: '确定移动',
    //         cancelButtonText: '取消移动',
    //         type: 'warning',
    //       }
    //   ).then(() => {
    //     this.oneMoveBackLoading = true;
    //     this.loading = true;
    //     let params = {wujian_id: this.thing, endTime: this.endTime}
    //     this.$axios.post('mfg/paintingProduction/oneClickMoveBack', params).then(response => {
    //       this.oneMoveBackLoading = false;
    //       let res = response.data
    //       if (res.code !== 0) {
    //         this.loading = false;
    //         return this.$message.error(res.message);
    //       }
    //
    //       this.getBatchNos();
    //       return this.$message.success("移动成功");
    //     }, error => {
    //       this.$message.error(`页面数据加载失败` + error.message);
    //       this.loading = false;
    //     })
    //   }).catch(() => {
    //     ElMessage({
    //       type: 'info',
    //       message: '取消成功',
    //     })
    //   })
    // },
    async saveWujianOneBatchData() {
      this.splitBatchItemBool = false;
      this.loading = true;
      //console.log("saveWujianDataClick=", this.formWujianData)
      let params = {batchNoList: this.batchNoList, formWujianData: this.formWujianData}
      this.$axios.post('mfg/paintingProduction/saveWujianOneBatchData', params).then(async response => {
        let res = response.data
        if (res.code !== 0) {
          await this.getBatchNos();
          return this.$message.error(res.message);
        }

        await this.getBatchNos();
        return this.$message.success("提交成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    cancelEvent1() {
      this.remarkBool = false;
      return this.$message.success("取消成功");
    },
    async confirmEvent2() {
      this.remarkBool = false;
      this.remarkParams.remark = this.remark;
      this.$axios.post('mfg/paintingProduction/editRemarks', this.remarkParams).then(async response => {
        let res = response.data
        if (res.code !== 0) {
          await this.getBatchNos();
          return this.$message.error(res.message);
        }

        await this.getBatchNos();
        return this.$message.success("提交成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    //添加产线备注
    editRemarks(lineCnt) {
      //console.log("editRemarks==", lineCnt)
      this.remark = lineCnt.remark;
      this.remarkBool = true;
      this.remarkParams = {class_line_name: lineCnt.class_line_name}
    },
    //根据批号查询排产详情
    selectProductionAll() {
      // if (!this.thing) {
      //   return this.$message.error("物件不能为空");
      // }
      if (!this.batchNo) {
        return;
      }
      this.batchQueryLoading = true;
      this.loading = true;
      let params = {batchNo: this.batchNo}
      this.$axios.post('mfg/paintingProduction/selectProductionAll', params).then(response => {
        this.loading = false;
        this.batchQueryLoading = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }

        this.state.dataList = res.data;
        return this.$message.success("查询成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //本周
    async clickThisWeek() {
      if (!this.thing) {
        return this.$message.error("物件不能为空");
      }
      this.loading = true;
      let obj = this.getCurrWeekDays();
      this.formatTime(obj.startTime, obj.endTime);
      await this.getBatchNos();

    },
    //上周
    async clickLastWeek() {
      if (!this.thing) {
        return this.$message.error("物件不能为空");
      }
      this.loading = true;
      let obj = this.getLastWeekDays(this.startTime, this.endTime);
      this.formatTime(obj.startTime, obj.endTime);
      await this.getBatchNos();

    },
    //下周
    async clickNextWeek() {
      if (!this.thing) {
        return this.$message.error("物件不能为空");
      }
      this.loading = true;
      let obj = this.getBelowWeekDays(this.startTime, this.endTime);
      this.formatTime(obj.startTime, obj.endTime);
      await this.getBatchNos();
    },
    // 获取本周开始结束时间
    getCurrWeekDays() {
      let obj = {
        startTime: '',
        endTime: ''
      }

      let endDate = new Date(this.assemblyEndTime); // 结束日期
      obj.startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      obj.endTime = moment(endDate.valueOf()).format('YYYY-MM-DD');
      return obj
    },
    // 获取上一周的开始结束时间
    getLastWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(-7, 'days').format('YYYY-MM-DD');
      obj.endTime = moment(endTime).add(-7, 'days').format('YYYY-MM-DD');
      return obj
    },
    // 获取下一周的开始结束时间
    getBelowWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(7, 'days').format('YYYY-MM-DD');
      obj.endTime = moment(endTime).add(7, 'days').format('YYYY-MM-DD');
      return obj
    },
    //处理时间
    formatTime(startTime, endTime) {
      console.log("startTime=", startTime)
      console.log("endTime=", endTime)
      this.startTime = startTime;
      this.endTime = endTime;
      this.week = [];
      this.weekList = [];
      let startDate = moment(startTime).add(-1, 'days');
      let endDate = moment(endTime);
      while (startDate.isBefore(endDate)) {
        startDate.add(1, 'days');
        let date = moment(startDate).format('YYYY-MM-DD')
        let time = moment(date).format('MM') + "月" + moment(date).format('DD') + "日";
        this.weekList.push({time});
      }

      let weeks = ["一", "二", "三", "四", "五", "六", "日"]
      let cnt = 0;
      for (let i = 0; i < this.weekList.length; i++) {
        if (i === 7) {
          cnt = 0;
        }
        this.weekList[i]['week'] = "(" + weeks[cnt] + ")";
        cnt += 1;
      }

      this.startDate = moment(startTime).format('MM') + "-" + moment(startTime).format('DD');
      this.endDate = moment(endTime).format('MM') + "-" + moment(endTime).format('DD');
      this.week.push(this.startDate);
      this.week.push(this.endDate);
    },
    getAssemblyEndTime() {
      let startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      let endTime = moment(moment().week(moment().week()).endOf('week').add(8, 'days').valueOf()).format('YYYY-MM-DD');
      let params = {startTime: startTime, endTime: endTime};
      this.$axios.post('mfg/paintingProduction/getAssemblyEndTime', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("组立最后排产时间为空");
        }

        this.assemblyEndTime = res.data;
        let obj = this.getCurrWeekDays();
        this.formatTime(obj.startTime, obj.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    getMaxHeight() {
      let h_max = 0;
      const widthBox = document.getElementsByClassName('data_style');
      for (let i = 0; i < widthBox.length; i++) {
        if (h_max < widthBox[i].clientHeight) {
          h_max = widthBox[i].clientHeight;
        }
      }

      let totalHeight = this.$refs.total_height.clientHeight;
      let timeHeight = totalHeight * 0.06;
      let pageHeight = totalHeight - timeHeight - 15;
      if (h_max < pageHeight) {
        h_max = pageHeight;
      }

      this.maxHeight = "height: " + h_max + "px;";
    },
    getStyle1(batchItem) {
      if (batchItem.process_num === 0) {
        return "border-left: #f56c6c 3px solid";
      } else if (batchItem.process_num > 0 && batchItem.process_num < batchItem.process_unit_num) {
        return "border-left: #e6a23c 3px solid";
      } else {
        return "border-left: #67c23a 3px solid";
      }
    },
    getStyle2(batchItem) {
      let style = "";
      if (batchItem.painting_num === 0) {
        style += "border-right: #f56c6c 3px solid;"
      } else if (batchItem.painting_num > 0 && batchItem.painting_num < batchItem.unit_num) {
        style += "border-right: #e6a23c 3px solid;"
      } else {
        style += "border-right: #67c23a 3px solid;"
      }

      if (batchItem.process_num === 0) {
        style += "border-left: #f56c6c 3px solid";
      } else if (batchItem.process_num > 0 && batchItem.process_num < batchItem.process_unit_num) {
        style += "border-left: #e6a23c 3px solid";
      } else {
        style += "border-left: #67c23a 3px solid";
      }

      return style;
    },
    destructionCheckSaveStatus() {
      let params = {thing: this.thing, startTime: this.startTime, endTime: this.endTime}
      this.wujianId = JSON.parse(localStorage.getItem("paintingWujianId"))
      if (this.wujianId) {
        params.thing = this.wujianId;
      }
      if (!params.thing) {
        return
      }
      this.$axios.post('mfg/paintingProduction/checkSaveStatus', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }
        //console.log("checkSaveStatus==", res.data)
        if (res.data) {
          let windowObj = {}
          windowObj.icon = "system/view";
          windowObj.component = "bus/make_schedule/PaintingDialog";
          windowObj.name = '涂装排产提示';
          windowObj.parentData = params;
          windowObj.height = 600 || this.$store.getters['core/getGlobalWindowHeight']
          windowObj.width = 1100 || this.$store.getters['core/getGlobalWindowWidth']
          windowObj.no_min = true
          windowObj.max = true

          this.$store.dispatch('core/openWindow', windowObj)
        }
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    }
  }, created() {
    this.getAssemblyEndTime();
    this.getWuJianInFo();
  }, beforeUnmount() {
    this.destructionCheckSaveStatus();
  }
}
</script>

<style scoped>
.border {
  border: rgb(216, 220, 230) 1px solid;
}

.color {
  background-color: #e7e7e7;
}

.center {
  text-align: center;
  line-height: 32px;
}

.cursor {
  cursor: pointer;
}

.item3 {
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color: whitesmoke;
}

/*一下是拖拽样式*/
.item {
  border: solid 2px #0478e4 !important;
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color: whitesmoke;
}

.is_other_wujian_style {
  border: solid 2px #8a9197 !important;
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color: whitesmoke;
}

.item1 {
  border-top: dashed 1px #a9aeb7 !important;
  font-size: 14px;
  color: black;
  text-align: center;
  background-color: whitesmoke;
}

.item2 {
  border: solid 2px #0478e4 !important;
  font-size: 6px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color: #e7e7e7;
}

.item2:hover {
  background-color: whitesmoke;
}

.chosenClass {
  font-size: 13px;
  font-weight: bold;
}

/*button样式*/
.button {
  color: white;
  border-radius: 5px 5px 0 0;
  width: 100%;
  margin-top: 5px;
}

/*div样式*/
.week {
  border: #909399 0 solid;
  background-color: white;
  color: rgb(4, 134, 254);
}

.total_style {
  width: auto;
  align-items: center;
  margin-left: 5px;
  margin-top: 1px;
}

.time {
  width: 100%;
  text-align: center;
  margin-top: 5px;
}

.data_style {
  width: 224px;
  height: auto;
}

.data_style1 {
  width: 224px;
  height: auto;
  background-color: #e7e7e7;
  margin-top: 5px;
  border: rgb(216, 220, 230) 2px solid;
}

.data_style2 {
  margin-top: 5px;
  border: rgb(216, 220, 230) 2px solid;
}

.data_style3 {
  width: 100%;
  background-color: rgb(228, 231, 237);
  color: white;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.data_style4 {
  background-color: #0478e4;
  font-size: 14px;
}

.data_style4_1 {
  color: black;
  margin-left: 2px;
  font-size: 14px;
}

.scrollbar::-webkit-scrollbar {
  display: none;
}

.prompt {
  color: rgba(0, 0, 0, 0.2);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.initHeight {
  border: #d8dce6 2px solid;
  height: 50px;
}

.overflow-text {
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 显示省略号 */
  width: 100%; /* 设置容器的宽度 */
  position: relative; /* 为悬停时显示的提示框做准备 */
}

.custom-tooltip {
  width: 150px; /* 设置提示框的宽度 */
  max-height: 200px; /* 设置提示框的最大高度 */
  overflow-y: auto; /* 如果内容超出高度，显示滚动条 */
}


</style>